<template>
  <div>
    <!-- create dialog -->
    <dialogTemplate
      :openDialog="isOpen"
      :widthDialog="'700px'"
      :classDialog="'createDialog'"
      :offsetTop="''"
      @closeDialog="$emit('closeDialog')"
      @closed="$emit('closed')"
    >
      <template #body>
        <h3 class="dialogTitle margin-left-0">Đăng nhập Smart CA</h3>
        <el-form
          :model="form"
          :rules="rules"
          ref="form"
          label-position="left"
          label-width="130px"
        >
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="Tài khoản" prop="username">
                <el-input
                  class="
                    style-fullWidth
                    input-border__bottom input-border__radius__0
                  "
                  v-model="form.username"
                  size="mini"
                  placeholder="-"
                  maxlength="20"
                  @input="oldPasswordError = false"
                >
                </el-input>
                <div v-if="oldPasswordError" class="el-form-item__error">
                  Tài khoản hoặc password chưa chính xác!
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="Mật khẩu" prop="password">
                <el-input
                  class="
                    style-fullWidth
                    input-border__bottom input-border__radius__0
                  "
                  v-model="form.password"
                  size="mini"
                  placeholder="-"
                  maxlength="20"
                  type="password"
                  show-password
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>

      <template #footer>
        <div class="flex-row flex__between">
          <div class="flex__right form-button__action">
            <el-button
              type="success"
              size="mini"
              class="addDocs btn-none__border color__white bg__blue"
              @click="save"
              :disabled="isUploading || isSubmitting"
            >
              <span class="flex-row flex__center">
                <i
                :class="[
                  !isUploading && !isSubmitting
                    ? 'fas fa-save'
                    : 'el-icon-loading',
                ]"
              ></i>
                &nbsp;&nbsp;Xác nhận
              </span>
            </el-button>
            <el-button
              type="info"
              size="mini"
              class="btn__cancel btn-none__border"
              @click="cancel"
            >
              <span class="flex-row flex__center">
                <i class="far fa-times-circle font-size__medium"></i>
                &nbsp;&nbsp;Hủy
              </span>
            </el-button>
          </div>
        </div>
      </template>
    </dialogTemplate>
  </div>
</template>

<script>
import dateFormatter from "../../../filters/dateFormatter";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";

export default {
  name: "dialog-change-password",
  mixins: [handleRequestErrorMixin],
  props: ["isOpen", "isSubmitting"],
  filters: { dateFormatter },
  components: {
    dialogTemplate: () => import("../custom-dialog.vue"),
  },
  data() {
    return {
      isUploading: false,
      user: {},
      form: {
        username: null,
        password: null,
      },
      oldPasswordError: false,
      rules: {
        username: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "blur",
          },
        ],
      },
    };
  },

  methods: {
    cancel() {
      this.$emit("closeDialog");
    },

    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.isUploading = true;
        let submitForm = {
          username: this.form.username,
          password: this.form.password,
        };
        this.signVb(submitForm)
          .then(() => {
            this.isUploading = false;
            // this.oldPasswordError = true;
          });
      });
    },

    async signVb(submitForm) {
      await this.$emit("success", submitForm);
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/common/noteDocs/LoginSCA.vue